// extracted by mini-css-extract-plugin
module.exports = {"constructor":"constructor__18lq6","contacts":"contacts__2ANqX","header":"header__3NAOv"};